import React, { useState } from "react"
import { Link } from "gatsby"
import { Card, Row, Col } from "react-bootstrap"
import Img from "gatsby-image"
const Post = ({ title, slug, date, body, show, fluid }) => {
  const [posthover, setposthover] = useState(false)
  return (
    <Card className={posthover ? "each-post-hover" : "each-post"}>
      <Img className="each-post-image" fluid={fluid} />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="each-post-bg"
        viewBox="0 0 110.886 105"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="0.576"
            y1="0.541"
            x2="0.043"
            y2="0.976"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stop-color="#5b3c81" />
            <stop offset="1" stop-color="#415283" />
          </linearGradient>
          <filter id="f3" x="0" y="-5" width="200%" height="200%">
            <feOffset result="offOut" in="SourceAlpha" dx="0" dy="-5" />
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="10" />
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
          </filter>
        </defs>
        <path
          id="Intersection_1"
          data-name="Intersection 1"
          d="M13,112.862A13,13,0,0,1,.113,101.586V29.566S111,54.417,111,8.668V99.861a13,13,0,0,1-13,13Z"
          transform="translate(-0.113 -7.862)"
        />
      </svg>

      <Card.Body>
        <Row className="justify-content-md-center">
          <Col xl="12">
            <Card.Subtitle>
              <span className="post-subtitle">{date}</span>
            </Card.Subtitle>
          </Col>
          <Col xl="12">
            <Card.Title>
              <Link
                className={
                  posthover ? "each-post-title-hover" : "each-post-title"
                }
                to={slug}
              >
                {title}
              </Link>
            </Card.Title>
          </Col>
          <Col xl="12">
            <Card.Text className="each-post-text">{body}</Card.Text>
          </Col>
        </Row>
      </Card.Body>
      <Link to={slug}>
        <div
          className="post-onhover-action"
          onMouseEnter={() => {
            setposthover(true)
            console.log("trueeeeeeeeee")
          }}
          onMouseLeave={() => {
            setposthover(false)
            console.log("trueeeeeeeeee")
          }}
        ></div>
      </Link>
    </Card>
  )
}
export default Post
